<div class="form-group mb-20">
    <label class="control-label col-xs-9">
        {{ "control_animation_on_scroll" | translate }}
        @if (isDisabled()) {
            <span
                class="small sp-icon icon-question color-light hover-effect"
                [tooltip]="'animation_disabled_tooltip' | translate"
                [placement]="'top'"
                [adaptivePosition]="true"
                triggers="mouseover:mouseleave"
            ></span>
        }
    </label>
    <div class="col-xs-3 control-switch text-right" [class.disabled]="isDisabled()">
        <sp-switch
            [active]="effectiveIsActive()"
            [disabled]="isDisabled()"
            (toggleActiveEvent)="onToggleIsActive($event)"
        />
    </div>
</div>

@if (effectiveIsActive()) {
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_animation_type" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" [formField]="field().animationType" (change)="onTypeChange($event)">
                <option value="fade">{{ "Fade" | translate }}</option>
                <option value="scale">{{ "Scale" | translate }}</option>
                <option value="slide">{{ "Slide" | translate }}</option>
            </select>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_animation_position" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" [formField]="field().animationPosition">
                <option value="left">{{ "option_animation_position_left" | translate }}</option>
                <option value="top">{{ "option_animation_position_top" | translate }}</option>
                <option value="right">{{ "option_animation_position_right" | translate }}</option>
                <option value="bottom">{{ "option_animation_position_bottom" | translate }}</option>
                @if (animationType() === "fade") {
                    <option value="center">{{ "option_animation_position_center" | translate }}</option>
                }
            </select>
        </div>
    </div>

    <div class="form-group">
        <label class="col-xs-12">
            {{ "control_animation_speed" | translate }}
        </label>
        <div class="col-xs-12">
            <select class="form-control" [formField]="field().animationSpeed">
                <option value="slow">{{ "option_animation_speed_slow" | translate }}</option>
                <option value="medium">{{ "option_animation_speed_medium" | translate }}</option>
                <option value="fast">{{ "option_animation_speed_fast" | translate }}</option>
            </select>
        </div>
    </div>
}
